export default "__VITE_ASSET__BMVspeih__"